export const MAX_YEARS_IN_PICKER = 10;
export const TIME_INTERVAL = 15;

export const DatePickerConfig = {
  showYearDropdown: true,
  showMonthDropdown: true,
  yearDropdownItemNumber: MAX_YEARS_IN_PICKER,
  isClearable: true,
  showPopperArrow: false,
  popperPlacement: "bottom-start",
};
